import React from 'react';
import PropTypes from 'prop-types';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

const DATE_FORMAT_ACCESSO = 'yyyy-MM-dd';

class SimpleDate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      month: '',
      day: '',
      year: '',
      error: ''
    };
  }

  componentDidMount() {
    this.setInitialValues();
  }

  updateDate() {
    const { month = '', day = '', year = '' } = this.state;
    let isValid = false;
    let formattedDate = '';

    if (month && day && year) {
      try {
        const parsedDate = parse(
          `${month}/${day}/${year}`,
          'MM/dd/yyyy',
          new Date()
        );
        formattedDate = format(parsedDate, DATE_FORMAT_ACCESSO);
        isValid = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        isValid = false;
      }

      if (isValid && this.props.onChange) {
        this.props.onChange(formattedDate);
      }
    }
  }

  setInitialValues() {
    let { month, day, year, value } = this.props;

    if (value) {
      try {
        const parsedDate = parse(value, DATE_FORMAT_ACCESSO, new Date());
        year = parsedDate.getFullYear();
        month = parsedDate.getMonth() + 1;
        day = parsedDate.getDate();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }

    this.setState({
      month,
      day,
      year
    });
  }

  handleDayChange(e) {
    let d = parseInt(e.target.value, 10);
    if (isNaN(d)) {
      d = '';
    }

    if (e.target.value.length < 3 && d < 32) {
      this.setState(prevState => ({
        ...prevState,
        day: d
      }));
    }
  }

  handleMonthChange(e) {
    let m = parseInt(e.target.value, 10);
    if (isNaN(m)) {
      m = '';
    }

    if (e.target.value.length < 3 && m < 13) {
      this.setState(prevState => ({
        ...prevState,
        month: m
      }));
    }
  }

  handleYearChange(e) {
    let y = parseInt(e.target.value, 10);
    if (isNaN(y)) {
      y = '';
    }

    if (e.target.value.length < 5) {
      this.setState(prevState => ({
        ...prevState,
        year: y
      }));
    }
  }

  render() {
    const { name } = this.props;

    return (
      <div className="sw-form-module__date">
        <div className="sw-form-module__date-simple-input-wrapper">
          <label htmlFor={`swformfield__control--date-month-${name}`}>
            Month (2-digit)
          </label>
          <input
            id={`swformfield__control--date-month-${name}`}
            name={`swformfield__control--date-month-${name}`}
            value={this.state.month || ''}
            onChange={e => {
              e.persist();
              this.handleMonthChange(e);
            }}
            onBlur={() => this.updateDate()}
            className="swformfield__control"
            type="number"
            max="12"
            placeholder="MM"
          />
        </div>
        <div className="sw-form-module__date-simple-input-wrapper">
          <label htmlFor={`swformfield__control--date-day-${name}`}>
            Day (2-digit)
          </label>
          <input
            name={`swformfield__control--date-day-${name}`}
            id={`swformfield__control--date-day-${name}`}
            value={this.state.day || ''}
            onChange={e => {
              e.persist();
              this.handleDayChange(e);
            }}
            onBlur={() => this.updateDate()}
            className="swformfield__control"
            type="number"
            max="31"
            placeholder="DD"
          />
        </div>
        <div className="sw-form-module__date-simple-input-wrapper sw-form-module__date-simple-input-wrapper-year">
          <label htmlFor={`swformfield__control--date-year-${name}`}>
            Year (4-digit)
          </label>
          <input
            name={`swformfield__control--date-year-${name}`}
            id={`swformfield__control--date-year-${name}`}
            value={this.state.year || ''}
            onChange={e => {
              e.persist();
              this.handleYearChange(e);
            }}
            onBlur={() => this.updateDate()}
            className="swformfield__control"
            type="number"
            placeholder="YYYY"
          />
        </div>
        {this.state.error && (
          <span style={{ color: 'red' }}>{this.state.error}</span>
        )}
      </div>
    );
  }
}

SimpleDate.propTypes = {
  month: PropTypes.number,
  day: PropTypes.number,
  year: PropTypes.number,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

export default SimpleDate;
